import { NavItem } from "../types/nav";

export const navItems: NavItem[] = [
  {
    key: "consents",
    label: "My Consents",
    getHref: () => "/my-consents",
    isActive: (pathname) =>
      pathname === "/my-consents" ||
      /^\/consents\/[^/]+$/.test(pathname) ||
      /^\/consents\/[^/]+\/(?!my-data$|requests$)[^/]+$/.test(pathname),
    icon: "/assets/consent.svg",
    iconDark: "/assets/consents-dark.svg",
  },
  {
    key: "my-data",
    label: "My Data",
    getHref: () =>
      `/consents/${localStorage.getItem("tenant_id") || ""}/my-data`,
    isActive: (pathname) => /^\/consents\/[^/]+\/my-data$/.test(pathname),
    icon: "/assets/my-data-white.svg",
    iconDark: "/assets/my-data-dark.svg",
  },
  {
    key: "requests-complaints",
    label: "Requests & Complaints",
    getHref: () => "/complaints",
    isActive: (pathname) => pathname === "/complaints",
    dividerBefore: true,
    icon: "/assets/request-white.svg",
    iconDark: "/assets/requests-complaints-dark.svg",
  },
  {
    key: "rights",
    label: "Rights & FAQs",
    getHref: () => "/rights",
    isActive: (pathname) => pathname === "/rights",
    icon: "/assets/help-white.svg",
    iconDark: "/assets/rights-nav-dark.svg",
  },
];
